import "./App.css";
import Header from "./components/1.Header/Header.jsx";
import Home from "./components/0.Home/Home.jsx";
import Footer from "./components/5.Footer/Footer.jsx";
import Infrastructure from "./components/Pages/Infrastructure/Infrastructure.jsx";
import Development from "./components/Pages/Development/Development.jsx";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop.jsx";
import { Route, Routes } from "react-router-dom";
import FAQ from "./components/Pages/FAQ/Development.jsx";
import HowToHire from "./components/Pages/Legal/HowToHire.jsx";
import Terms from "./components/Pages/Legal/Terms.jsx";
import Refunds from "./components/Pages/Legal/Refunds.jsx";
import Privacy from "./components/Pages/Legal/Privacy.jsx";
import LegalInfo from "./components/Pages/Legal/LegalInfo.jsx";

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/development" element={<Development />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/como-contratar" element={<HowToHire />} />
          <Route path="/terminos-y-condiciones" element={<Terms />} />
          <Route path="/politica-de-reembolsos" element={<Refunds />} />
          <Route path="/politica-de-privacidad" element={<Privacy />} />
          <Route path="/informacion-legal" element={<LegalInfo />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
}

export default App;
